export default {
  trainings: [],
  maxTrainings: 0,
  sessions: [],
  maxSessions: 0,
  trainees: [],
  maxTrainee: 0
}
